import { enableProdMode } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeSV from '@angular/common/locales/sv';
import { bootstrapApplication } from '@angular/platform-browser';

import { environment } from './environments/environment';
import { provideAppConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

registerLocaleData(localeSV);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: provideAppConfig(),
}).catch((err) => console.error(err));
